import { EnvironmentModel } from "./environment.model";

export const environment: EnvironmentModel = {
  baseUrlWs: "https://api-app.joinrs.com/api/",
  baseUrlApiAppUsers: "https://api-app-users.joinrs.com/",
  wsVerison: "v1/",
  production: true,
  baseUrl: "https://employer.joinrs.com",
  baseUrlV3: "https://www.joinrs.com",
  baseChatUrl: "https://chat.joinrs.com/chat",
  baseSocketUrl: "https://chat.joinrs.com/socket/chat",
  publicAppPath: "/p",
  // @ts-ignore
  appVersion: require("../../package.json").version,
  curriculumUrl: "https://ionic-app.joinrs.com",
  pdfMassiveDownload: false,
  clevertap: "R78-5K9-7Z5Z",
  unleash: {
    proxyUrl: "https://feature-flag-employer.joinrs.com/proxy",
    clientKey: "unleash-proxy-production",
    refreshInterval: 15,
    appName: "default",
    environment: "production",
  },
  flags: {
    resetPasswordEmailActive: true,
  },
  dataloopUrl: "https://dataloop.joinrs.com",
  jboxUrl: "https://jbox.joinrs.com",
};
